import Layout from '@layout/Index'

export const IntelligentCustomerServiceRoute = [
  {
    path: '/intelligent-customer-service',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'update',
      },
      {
        path: 'update',
        component: () => import(/* webpackChunkName: "intelligent-customer-service" */ './pages/IntelligentCustomerServiceForm.vue'),
        name: '参数配置',
        meta: {
          title: '参数配置',
        },
      }
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/intelligent-customer-service/intelligent-customer-service.route.js